<template>
  <div id="slideVerify" class="slide-verify">
    <header style="color: #333; font-size: 16px; padding: 10px 0 10px 0">
      {{ $t("verify.text") }}
    </header>
    <i class="icon-close-btn el-icon-close" @click.stop="handleClose" />

    <div :style="{ width: w + 'px', position: 'relative' }">
      <canvas ref="canvas" :width="w" :height="h" />
      <canvas
        ref="block"
        :width="sw"
        :height="sh"
        :style="{
          top: (verifyInfo.y * 171) / 360 + 'px',
          position: 'absolute',
        }"
      />

      <div
        class="slide-verify-status"
        :class="{ fail: containerFail, success: containerSuccess }"
        v-show="showInfo"
      >
        <img
          class="state-img"
          :src="
            require(containerSuccess ? '@/assets/live/success.png' : './icon-fail.png')
          "
          alt=""
        />
        <p class="state-text">{{ infoText }}</p>

        <footer
          class="flex-middle state-footer"
          style="color: #ddd; font-size: 16px"
        >
          <img src="./icon-jy.png" style="width: 23px; height: 23px" alt="" />
        </footer>
      </div>

      <div class="slide-verify-slider" :style="{ width: w + 'px' }">
        <div
          class="slide-verify-slider-mask flex-middle-only"
          :class="{ sliding: sliderMaskWidth > 0 }"
          :style="{ width: sliderMaskWidth + 'px' }"
        >
          <div
            class="slide-btn-container"
            :style="{ left: sliderLeft + 'px' }"
            @mousedown.stop="sliderDown"
            @touchstart.stop="touchStartEvent"
            @touchmove.stop="touchMoveEvent"
            @touchend.stop="touchEndEvent"
          >
            <div class="slide-btn flex-middle"></div>
          </div>
        </div>
        <span class="slide-verify-slider-text">{{ sliderText }}</span>
      </div>
    </div>

    <div class="flex-middle slide-verify-refresh-icon" @click.stop="refresh">
      <i class="el-icon-refresh-left" :class="{ rolling: loading }" />
      {{ $t("verify.fresh") }}
    </div>

    <div class="mask flex-middle flex-column" v-if="loading">
      <i class="el-icon-loading" style="font-size: 22px"></i>
      <span style="z-index: 9">{{ $t("common.loading") }}</span>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";

function sum(x, y) {
  return x + y;
}

function square(x) {
  return x * x;
}

export default {
  name: "slide-verify",
  props: {
    // block length
    l: {
      type: Number,
      default: 42,
    },
    // block radius
    r: {
      type: Number,
      default: 10,
    },
    // canvas width
    w: {
      // 背景图宽
      type: [Number, String],
      default: 350,
    },
    // canvas height
    h: {
      // 背景图高
      type: [Number, String],
      default: 200,
    },
    // canvas width
    sw: {
      // 小图宽
      type: [Number, String],
      default: 50,
    },
    // canvas height
    sh: {
      type: [Number, String],
      default: 50,
    },
  },

  data() {
    return {
      containerActive: false, // container active class
      containerSuccess: false, // container success class
      containerFail: false, // container fail class
      canvasCtx: null,
      blockCtx: null,
      block: null,
      canvasStr: null,
      img: undefined,
      originX: undefined,
      originY: undefined,
      isMouseDown: false,
      trail: [],
      sliderLeft: 0, // block right offset
      sliderMaskWidth: 0, // mask width
      infoText: this.$t("verify.success"),
      sliderText: this.$t("verify.rightSlide"),
      fail: false,
      showInfo: false,
      verifyInfo: {
        image: "",
        slide: "",
        y: 0,
        id: 0,
      },
      loading: false,
      verify_loading: false,
    };
  },
  mounted() {
    // 随机生成数this.block_x =
    this.init();
  },
  methods: {
    async init() {
      await this.initDom();
      this.bindEvents();
    },

    async initDom() {
      this.block = this.$refs.block;
      this.canvasStr = this.$refs.canvas;

      this.canvasCtx = this.canvasStr.getContext("2d");
      this.blockCtx = this.block.getContext("2d");
      try {
        await this.getVerifyImg();
        this.initImg();
      } catch (err) {
        console.log("err:", err);
      }
    },

    initImg() {
      const img = document.createElement("img");
      img.src = this.verifyInfo.image;

      img.onload = () => {
        this.canvasCtx.drawImage(img, 0, 0, this.w, this.h);
        this.loading = false;
      };

      img.onerror = () => {
        this.loading = false;
      };

      this.img = img;
      const img1 = document.createElement("img");
      const blockCtx = this.blockCtx;
      img1.src = this.verifyInfo.slide;
      img1.onload = () => {
        blockCtx.drawImage(img1, 0, 0, this.sw, this.sh);
      };
    },

    getVerifyImg() {
      this.loading = true;
      this.sliderText = "";
      return post({ url: "/api/captcha_path" })
        .then((res) => {
          if (res.status === 200 && res.data.status === 0) {
            this.verifyInfo = res.data?.data || {};
            this.sliderText = this.$t("verify.rightSlide");
          }
        })
        .catch((err) => {
          // console.log(err)
          this.loading = false;
        });
    },

    verifySlideImg() {
      this.verify_loading = true;
      const x = (parseInt(this.block.style.left) * 590) / this.w;
      const params = {
        id: this.verifyInfo.id,
        x: Math.floor(x),
      };
      post({ url: "/api/captcha_verify", data: params })
        .then((res) => {
          this.verify_loading = false;
          if (res.status === 200 && res.data.status === 0) {
            const result = res.data?.data;
            if (result) {
              this.handleSuccess(res.data);
            } else {
              this.handleFail();
            }
          }
        })
        .catch((err) => {
          this.verify_loading = false;
          this.handleFail();
          console.log(err);
        });
    },

    // 刷新
    refresh() {
      this.reset();
      this.initDom();
    },

    sliderDown(event) {
      this.originX = event.clientX;
      this.originY = event.clientY;
      this.isMouseDown = true;
    },

    touchStartEvent(e) {
      console.log("touchStartEvent", e);
      this.originX = e.changedTouches[0].pageX;
      this.originY = e.changedTouches[0].pageY;
      this.isMouseDown = true;
    },

    bindEvents() {
      document.addEventListener("mousemove", (e) => {
        if (!this.isMouseDown) return false;
        console.log("mousemove", e);
        const moveX = e.clientX - this.originX;
        const moveY = e.clientY - this.originY;
        if (moveX < 0 || moveX + 62 >= this.w) return false;
        this.sliderLeft = moveX;
        // 计算拼图的相对距离
        const blockLeft = ((this.w - this.sw) / (this.w - 62)) * moveX;
        this.block.style.left = blockLeft + "px";
        this.containerActive = true;
        // 包裹滑块按钮
        this.sliderMaskWidth = Math.min(moveX + 62, this.w);
        this.trail.push(moveY);
      });
      document.addEventListener("mouseup", (e) => {
        if (!this.isMouseDown) return false;
        this.isMouseDown = false;
        if (e.clientX === this.originX) return false;
        this.containerActive = false;
        this.verifySlideImg();
      });
    },

    touchMoveEvent(e) {
      console.log("touchMoveEvent", e);
      if (!this.isMouseDown) return false;
      const moveX = e.changedTouches[0].pageX - this.originX;
      const moveY = e.changedTouches[0].pageY - this.originY;
      if (moveX < 0 || moveX + 38 >= this.w) return false;
      this.sliderLeft = moveX;
      const blockLeft = ((this.w - 62) / (this.w - this.sw)) * moveX;
      this.block.style.left = blockLeft + "px";

      this.containerActive = true;
      this.sliderMaskWidth = Math.min(moveX, this.w);
      this.trail.push(moveY);
    },

    touchEndEvent(e) {
      if (!this.isMouseDown) return false;
      this.isMouseDown = false;
      if (e.changedTouches[0].pageX === this.originX) return false;
      this.containerActive = false;
      // this.verify()
      this.verifySlideImg();
    },

    reset() {
      this.containerActive = false;
      this.containerSuccess = false;
      this.containerFail = false;
      this.sliderLeft = 0;
      this.block.style.left = 0;
      this.sliderMaskWidth = 0;
      this.canvasCtx.clearRect(0, 0, this.w, this.h);
      this.blockCtx.clearRect(0, 0, this.sw, this.sh);
      this.fail = false;
      this.showInfo = false;
      this.containerFail = false;
    },

    handleClose() {
      this.$emit("close");
    },

    handleFail() {
      this.fail = true;
      this.showInfo = true;
      this.infoText = this.$t("verify.error");
      this.containerFail = true;
      setTimeout(() => {
        this.block.style.left = 0;
        this.sliderMaskWidth = 0;
        this.sliderLeft = 0;
        this.fail = false;
        this.showInfo = false;
        this.containerFail = false;
      }, 800);
    },

    handleSuccess(params) {
      this.showInfo = true;
      this.infoText = this.$t("verify.success");
      this.containerSuccess = true;
      setTimeout(() => {
        this.block.style.left = 0;
        this.sliderMaskWidth = 0;
        this.sliderLeft = 0;
        this.fail = false;
        this.showInfo = false;
        this.containerSuccess = false;
        this.$emit("success", params);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-verify {
  padding: 16px 20px;
  position: relative;
  width: 320px;
  overflow: hidden;
  background: linear-gradient(158.56deg, #ffeaf1 0%, #ffffff 42.59%);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
  border-radius: 0.16rem;
}

.slide-verify-refresh-icon {
  margin-top: 16px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}

.slide-verify-slider {
  position: relative;
  text-align: center;
  //width: 310px;
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  background: #f4f4f4;
  border-radius: 5px;
}

.slide-verify-slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 40px;
  border-radius: 5px;

  &.sliding {
    background: linear-gradient(
      90deg,
      rgba(255, 56, 56, 0.2) 0%,
      rgba(208, 45, 84, 0.2) 100%
    );
  }
}

.slide-verify-status {
  position: absolute;
  width: 100%;
  top: -2px;
  left: 0;
  right: 0;
  bottom: -2px;
  //box-shadow: 0 0 3px rgba(0, 0, 0, 0.05);
  //border-radius: 5px;
  z-index: 99;
  &.success {
    background: linear-gradient(158.56deg, #ffeaf1 0%, #ffffff 42.59%);
  }
  &.fail {
    background: linear-gradient(158.56deg, #ffede3 0%, #ffffff 42.59%);
  }

  .state-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 51px;
    border-top: 0.5px solid #f0f0f0;
  }

  .state-img {
    width: 68px;
    height: 68px;
    display: block;
    margin: 18px auto;
  }

  .state-text {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    color: #333;
  }
}

@keyframes hide {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.9;
  }
}

@keyframes rolling {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rolling {
  animation: rolling 1.6s infinite linear;
}

.slide-btn-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
  width: 62px;
  padding: 2px 3px;
  cursor: pointer;

  .slide-btn {
    width: 56px;
    height: 36px;
    background: linear-gradient(90deg, #be023d 0%, #421124 100%);
    box-shadow: 0 0 4px rgba(43, 20, 20, 0.5);
    border-radius: 5px;
    &:before {
      display: block;
      content: "";
      background-image: url("~@/components/slide-verify/slide-right-icon.png");
      width: 21px;
      height: 17px;
      background-size: 100% 100%;
    }
  }
}

.icon-close-btn {
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  padding: 5px;
  border: none;
  background-color: transparent;
  position: absolute;
  right: 11px;
  top: 11px;
}

.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  color: #fff;
  &::before {
    display: block;
    content: "";
    position: absolute;
    background: linear-gradient(
      90deg,
      rgb(163 173 169 / 70%) 0%,
      rgb(173 193 203 / 50%) 100%
    );
    filter: blur(12px);
    width: 100%;
    height: 100%;
  }
}
</style>
